module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "page_9"
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "fm-title"
  }, [_vm._v("GLOSSARY OF TERMS")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "dropcaps"
  }, [_vm._v("A")]), _vm._v("s the readership of this book may extend beyond railway enthusiasts, I have included the following glossary as a guide. At the end of the glossary are conversion tables for distance, volume and weight and a listing of distances between railway locations of particular relevance to this book.")]), _vm._v(" "), _c('table', [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "tab1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Term")])]), _vm._v(" "), _c('td', {
    staticClass: "tab2"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Meaning")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/09_Chapter01#glos_1",
      "id": "rglos_1"
    }
  }, [_vm._v("ASLEF")])])]), _vm._v(" "), _c('td', {
    staticClass: "tab2"
  }, [_vm._v("Associated Society of Locomotive Engineers and Firemen")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/20_Chapter11#glos_2",
      "id": "rglos_2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("banking of trains")])])]), _vm._v(" "), _c('td', {
    staticClass: "tab2"
  }, [_vm._v("the use of a locomotive at the rear of a train to push the train up an incline")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_Chapter05#glos_3",
      "id": "rglos_3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("BEA")])])]), _vm._v(" "), _c('td', {
    staticClass: "tab2"
  }, [_vm._v("British Electricity Authority")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16_Chapter07#glos_4",
      "id": "rglos_4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("block working")])])]), _vm._v(" "), _c('td', {
    staticClass: "tab2"
  }, [_vm._v("used in relation to trainloads of petroleum products")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/20_Chapter11#glos_5",
      "id": "rglos_5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("blooms, billets and slabs")])])]), _vm._v(" "), _c('td', {
    staticClass: "tab2"
  }, [_vm._v("descriptions of steel in a semi-finished state being sent between steelworks")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Chapter06#glos_6",
      "id": "rglos_6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("BRB")])])]), _vm._v(" "), _c('td', {
    staticClass: "tab2"
  }, [_vm._v("British Railways Board")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/10_Chapter02#glos_7",
      "id": "rglos_7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("BTC")])])]), _vm._v(" "), _c('td', {
    staticClass: "tab2"
  }, [_vm._v("British Transport Commission")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/13_Chapter04a#glos_8",
      "id": "rglos_8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CBP")])])]), _vm._v(" "), _c('td', {
    staticClass: "tab2"
  }, [_vm._v("Carriage Building Programme")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_Chapter05#glos_9",
      "id": "rglos_9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CEGB")])])]), _vm._v(" "), _c('td', {
    staticClass: "tab2"
  }, [_vm._v("Central Electricity Generating Board")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/09_Chapter01#glos_10",
      "id": "rglos_10"
    }
  }, [_vm._v("CLC")])])]), _vm._v(" "), _c('td', {
    staticClass: "tab2"
  }, [_vm._v("Cheshire Lines Committee")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/13_Chapter04a#glos_11",
      "id": "rglos_11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CME")])])]), _vm._v(" "), _c('td', {
    staticClass: "tab2"
  }, [_vm._v("Chief Mechanical Engineer")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/19_Chapter10#glos_12",
      "id": "rglos_12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CTCC")])])]), _vm._v(" "), _c('td', {
    staticClass: "tab2"
  }, [_vm._v("Central Transport Consultative Committee")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/09_Chapter01#glos_13",
      "id": "rglos_13"
    }
  }, [_vm._v("down")])])]), _vm._v(" "), _c('td', {
    staticClass: "tab2"
  }, [_vm._v("direction of travel away from London")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/13_Chapter04a#glos_14",
      "id": "rglos_14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ECJS")])])]), _vm._v(" "), _c('td', {
    staticClass: "tab2"
  }, [_vm._v("East Coast Joint Stock (carriages)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16_Chapter07#glos_15",
      "id": "rglos_15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("fitted freight")])])]), _vm._v(" "), _c('td', {
    staticClass: "tab2"
  }, [_vm._v("trains having continuous vacuum brakes on at least a proportion of the total number of wagons")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/09_Chapter01#glos_16",
      "id": "rglos_16"
    }
  }, [_vm._v("GC/GCR")])])]), _vm._v(" "), _c('td', {
    staticClass: "tab2"
  }, [_vm._v("Great Central Railway")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/09_Chapter01#glos_17",
      "id": "rglos_17"
    }
  }, [_vm._v("GDC")])])]), _vm._v(" "), _c('td', {
    staticClass: "tab2"
  }, [_vm._v("Grimsby Docks Company")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/09_Chapter01#glos_18",
      "id": "rglos_18"
    }
  }, [_vm._v("GENJ")])])]), _vm._v(" "), _c('td', {
    staticClass: "tab2"
  }, [_vm._v("Great Eastern Northern Junction Railway")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/09_Chapter01#glos_19",
      "id": "rglos_19"
    }
  }, [_vm._v("GER")])])]), _vm._v(" "), _c('td', {
    staticClass: "tab2"
  }, [_vm._v("Great Eastern Railway")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter04#glos_20",
      "id": "rglos_20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("GN/GE Jt")])])]), _vm._v(" "), _c('td', {
    staticClass: "tab2"
  }, [_vm._v("Great Northern and Great Eastern Joint(ly) owned line")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter04#glos_21",
      "id": "rglos_21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("GN/LNW/Jt")])])]), _vm._v(" "), _c('td', {
    staticClass: "tab2"
  }, [_vm._v("Great Northern, London and North Western Joint(ly) owned line")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/09_Chapter01#glos_22",
      "id": "rglos_22"
    }
  }, [_vm._v("GNR")])])]), _vm._v(" "), _c('td', {
    staticClass: "tab2"
  }, [_vm._v("Great Northern Railway")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/09_Chapter01#glos_23",
      "id": "rglos_23"
    }
  }, [_vm._v("GTR")])])]), _vm._v(" "), _c('td', {
    staticClass: "tab2"
  }, [_vm._v("Grand Trunk Railway of Canada")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/10_Chapter02#glos_24",
      "id": "rglos_24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("GW/GC")])])]), _vm._v(" "), _c('td', {
    staticClass: "tab2"
  }, [_vm._v("Great Western/Great Central line")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/09_Chapter01#glos_25",
      "id": "rglos_25"
    }
  }, [_vm._v("GWR")])])]), _vm._v(" "), _c('td', {
    staticClass: "tab2"
  }, [_vm._v("Great Western Railway")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/10_Chapter02#glos_26",
      "id": "rglos_26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("H&B")])])]), _vm._v(" "), _c('td', {
    staticClass: "tab2"
  }, [_vm._v("Hull & Barnsley Railway")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/09_Chapter01#glos_27",
      "id": "rglos_27"
    }
  }, [_vm._v("IFS")])])]), _vm._v(" "), _c('td', {
    staticClass: "tab2"
  }, [_vm._v("International Finance Society")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/09_Chapter01#glos_28",
      "id": "rglos_28"
    }
  }, [_vm._v("L&B")])])]), _vm._v(" "), _c('td', {
    staticClass: "tab2"
  }, [_vm._v("London and Birmingham Railway")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/09_Chapter01#glos_29",
      "id": "rglos_29"
    }
  }, [_vm._v("LCDR")])])]), _vm._v(" "), _c('td', {
    staticClass: "tab2"
  }, [_vm._v("London Chatham and Dover Railway")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_Chapter03#glos_30",
      "id": "rglos_30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("LDECR")])])]), _vm._v(" "), _c('td', {
    staticClass: "tab2"
  }, [_vm._v("Lancashire Derbyshire and East Coast Railway")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/18_Chapter09#glos_31",
      "id": "rglos_31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Liner trains")])])]), _vm._v(" "), _c('td', {
    staticClass: "tab2"
  }, [_vm._v("Concept of BRB which was a forerunner of Freightliner trains conveying demountable containers on flat wagons")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/09_Chapter01#glos_32",
      "id": "rglos_32"
    }
  }, [_vm._v("London extension")])])]), _vm._v(" "), _c('td', {
    staticClass: "tab2"
  }, [_vm._v("the route of the MS&LR/GCR South from Annesley")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/09_Chapter01#glos_33",
      "id": "rglos_33"
    }
  }, [_vm._v("L&M")])])]), _vm._v(" "), _c('td', {
    staticClass: "tab2"
  }, [_vm._v("Liverpool & Manchester Railway")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter04#glos_34",
      "id": "rglos_34",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("LMS")])])]), _vm._v(" "), _c('td', {
    staticClass: "tab2"
  }, [_vm._v("London Midland and Scottish Railway")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/10_Chapter02#glos_35",
      "id": "rglos_35",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("LNER")])])]), _vm._v(" "), _c('td', {
    staticClass: "tab2"
  }, [_vm._v("London and North Eastern Railway")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/09_Chapter01#glos_36",
      "id": "rglos_36"
    }
  }, [_vm._v("LNWR")])])]), _vm._v(" "), _c('td', {
    staticClass: "tab2"
  }, [_vm._v("London and North Western Railway")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_Chapter03#glos_37",
      "id": "rglos_37",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("LSWR")])])]), _vm._v(" "), _c('td', {
    staticClass: "tab2"
  }, [_vm._v("London and South Western Railway")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/09_Chapter01#glos_38",
      "id": "rglos_38"
    }
  }, [_vm._v("L&YR")])])]), _vm._v(" "), _c('td', {
    staticClass: "tab2"
  }, [_vm._v("Lancashire & Yorkshire Railway")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/09_Chapter01#glos_39",
      "id": "rglos_39"
    }
  }, [_vm._v("M&B")])])]), _vm._v(" "), _c('td', {
    staticClass: "tab2"
  }, [_vm._v("Manchester and Birmingham Railway")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_Chapter03#glos_40",
      "id": "rglos_40",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("MetR/GC")])])]), _vm._v(" "), _c('td', {
    staticClass: "tab2"
  }, [_vm._v("Metropolitan Railway Great Central jointly operated railway")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/09_Chapter01#glos_41",
      "id": "rglos_41"
    }
  }, [_vm._v("MR")])])]), _vm._v(" "), _c('td', {
    staticClass: "tab2"
  }, [_vm._v("Midland Railway")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/09_Chapter01#glos_42",
      "id": "rglos_42"
    }
  }, [_vm._v("MSJ&A")])])]), _vm._v(" "), _c('td', {
    staticClass: "tab2"
  }, [_vm._v("Manchester South Junction & Altrincham railway")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab1"
  }, [_c('a', {
    attrs: {
      "id": "page_10"
    }
  }), _c('span', {
    staticClass: "bold"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/09_Chapter01#glos_43",
      "id": "rglos_43"
    }
  }, [_vm._v("MS&LR")])])]), _vm._v(" "), _c('td', {
    staticClass: "tab2"
  }, [_vm._v("Manchester, Sheffield & Lincolnshire Railway")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter04#glos_44",
      "id": "rglos_44",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("NB")])])]), _vm._v(" "), _c('td', {
    staticClass: "tab2"
  }, [_vm._v("North British Railway")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_Chapter05#glos_45",
      "id": "rglos_45",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("NCB")])])]), _vm._v(" "), _c('td', {
    staticClass: "tab2"
  }, [_vm._v("National Coal Board")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/09_Chapter01#glos_46",
      "id": "rglos_46"
    }
  }, [_vm._v("NER")])])]), _vm._v(" "), _c('td', {
    staticClass: "tab2"
  }, [_vm._v("North Eastern Railway")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/20_Chapter11#glos_47",
      "id": "rglos_47",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("NE/SW")])])]), _vm._v(" "), _c('td', {
    staticClass: "tab2"
  }, [_vm._v("North East/South West cross-country route")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/09_Chapter01#glos_48",
      "id": "rglos_48"
    }
  }, [_vm._v("NLR/North Ldn")])])]), _vm._v(" "), _c('td', {
    staticClass: "tab2"
  }, [_vm._v("North London Railway")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("OAGBM")])]), _vm._v(" "), _c('td', {
    staticClass: "tab2"
  }, [_vm._v("Oldham Ashton and Guide Bridge Railway")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16_Chapter07#glos_49",
      "id": "rglos_49",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("pick up goods")])])]), _vm._v(" "), _c('td', {
    staticClass: "tab2"
  }, [_vm._v("goods train calling at intermediate stations to collect/leave wagons as required")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16_Chapter07#glos_50",
      "id": "rglos_50",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Q")])])]), _vm._v(" "), _c('td', {
    staticClass: "tab2"
  }, [_vm._v("train within Working Timetable which was run only as traffic or other circumstance required")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/09_Chapter01#glos_51",
      "id": "rglos_51"
    }
  }, [_vm._v("railway mania")])])]), _vm._v(" "), _c('td', {
    staticClass: "tab2"
  }, [_vm._v("speculation led trading in railway shares")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_Chapter03#glos_52",
      "id": "rglos_52",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("RCH")])])]), _vm._v(" "), _c('td', {
    staticClass: "tab2"
  }, [_vm._v("Railway Clearing House")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_Chapter05#glos_53",
      "id": "rglos_53",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("RE")])])]), _vm._v(" "), _c('td', {
    staticClass: "tab2"
  }, [_vm._v("Railway Executive")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/09_Chapter01#glos_54",
      "id": "rglos_54"
    }
  }, [_vm._v("route miles")])])]), _vm._v(" "), _c('td', {
    staticClass: "tab2"
  }, [_vm._v("distance between locations irrespective of whether single or more tracks")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/13_Chapter04a#glos_55",
      "id": "rglos_55",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ruling gradient")])])]), _vm._v(" "), _c('td', {
    staticClass: "tab2"
  }, [_vm._v("the limit of gradients along a route")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/09_Chapter01#glos_56",
      "id": "rglos_56"
    }
  }, [_vm._v("S&LJR")])])]), _vm._v(" "), _c('td', {
    staticClass: "tab2"
  }, [_vm._v("Sheffield and Lincolnshire Junction Railway")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/09_Chapter01#glos_57",
      "id": "rglos_57"
    }
  }, [_vm._v("S&MR")])])]), _vm._v(" "), _c('td', {
    staticClass: "tab2"
  }, [_vm._v("Sheffield and Manchester Railway")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/09_Chapter01#glos_58",
      "id": "rglos_58"
    }
  }, [_vm._v("SER")])])]), _vm._v(" "), _c('td', {
    staticClass: "tab2"
  }, [_vm._v("South Eastern Railway")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/13_Chapter04a#glos_59",
      "id": "rglos_59",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SR")])])]), _vm._v(" "), _c('td', {
    staticClass: "tab2"
  }, [_vm._v("Southern Railway")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_Chapter03#glos_60",
      "id": "rglos_60",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("S&T")])])]), _vm._v(" "), _c('td', {
    staticClass: "tab2"
  }, [_vm._v("Signal & Telegraph/Telecommunications")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Chapter06#glos_61",
      "id": "rglos_61",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("track miles")])])]), _vm._v(" "), _c('td', {
    staticClass: "tab2"
  }, [_vm._v("distance between locations for all tracks as laid")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/19_Chapter10#glos_62",
      "id": "rglos_62",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("TUCC")])])]), _vm._v(" "), _c('td', {
    staticClass: "tab2"
  }, [_vm._v("Transport Users Consultative Committee")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/09_Chapter01#glos_63",
      "id": "rglos_63"
    }
  }, [_vm._v("turn")])])]), _vm._v(" "), _c('td', {
    staticClass: "tab2"
  }, [_vm._v("a working for a crew or locomotive")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/09_Chapter01#glos_64",
      "id": "rglos_64"
    }
  }, [_vm._v("up")])])]), _vm._v(" "), _c('td', {
    staticClass: "tab2"
  }, [_vm._v("direction of travel towards London")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/09_Chapter01#glos_65",
      "id": "rglos_65"
    }
  }, [_vm._v("WM&CQR")])])]), _vm._v(" "), _c('td', {
    staticClass: "tab2"
  }, [_vm._v("Wrexham Mold & Connahs Quay Railway")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16_Chapter07#glos_66",
      "id": "rglos_66",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("WTT")])])]), _vm._v(" "), _c('td', {
    staticClass: "tab2"
  }, [_vm._v("Working Timetable for internal railway use")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/17_Chapter08#glos_67",
      "id": "rglos_67",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1 in 100")])])]), _vm._v(" "), _c('td', {
    staticClass: "tab2"
  }, [_vm._v("a gradient where the track rises or falls at a rate of one foot in one hundred feet")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/20_Chapter11#glos_68",
      "id": "rglos_68",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4V34")])])]), _vm._v(" "), _c('td', {
    staticClass: "tab2"
  }, [_vm._v("later BRB method of identifying trains. The first character represented the classification (0-9), the second the Region/location of destination and the third/fourth the train number. Shown on power signal box panels and on front of locomotives.")])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Conversion tables:")]), _vm._v(" "), _c('table', {
    staticClass: "table1"
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "tab3"
  }, [_vm._v("1 mile")]), _vm._v(" "), _c('td', {
    staticClass: "tab4"
  }, [_vm._v("=")]), _vm._v(" "), _c('td', {
    staticClass: "tab5"
  }, [_vm._v("1.60934 kilometres")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab3"
  }, [_vm._v("1 yard")]), _vm._v(" "), _c('td', {
    staticClass: "tab4"
  }, [_vm._v("=")]), _vm._v(" "), _c('td', {
    staticClass: "tab5"
  }, [_vm._v("0.9164 metre")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab3"
  }, [_vm._v("1 foot")]), _vm._v(" "), _c('td', {
    staticClass: "tab4"
  }, [_vm._v("=")]), _vm._v(" "), _c('td', {
    staticClass: "tab5"
  }, [_vm._v("0.3048 metre")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab3"
  }, [_vm._v("1 inch")]), _vm._v(" "), _c('td', {
    staticClass: "tab4"
  }, [_vm._v("=")]), _vm._v(" "), _c('td', {
    staticClass: "tab5"
  }, [_vm._v("2.54 centimetres")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab3"
  }, [_vm._v("1 gallon")]), _vm._v(" "), _c('td', {
    staticClass: "tab4"
  }, [_vm._v("=")]), _vm._v(" "), _c('td', {
    staticClass: "tab5"
  }, [_vm._v("4.54596 litres")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab3"
  }, [_vm._v("1 ton")]), _vm._v(" "), _c('td', {
    staticClass: "tab4"
  }, [_vm._v("=")]), _vm._v(" "), _c('td', {
    staticClass: "tab5"
  }, [_vm._v("1.016 tonne")])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("Distances in miles between major railway locations:")]), _vm._v(" "), _c('table', [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "tab1a"
  }, [_vm._v("London (Marylebone)-Manchester (London Road) via MetR/GC route:")]), _vm._v(" "), _c('td', {
    staticClass: "tab2a"
  }, [_vm._v("201")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab1a"
  }, [_vm._v("London (Euston)-Manchester (London Road) via Crewe and Wilmslow:")]), _vm._v(" "), _c('td', {
    staticClass: "tab2a"
  }, [_vm._v("189")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab1a"
  }, [_vm._v("London (St Pancras)-Manchester (Central) via Sharnbrook/Leicester/Trent/Derby:")]), _vm._v(" "), _c('td', {
    staticClass: "tab2a"
  }, [_vm._v("189")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab1a"
  }, [_vm._v("London (King’s Cross)-Manchester (London Road)via Welwyn/Retford/Sheffield (Victoria):")]), _vm._v(" "), _c('td', {
    staticClass: "tab2a"
  }, [_vm._v("201")])])])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0010-01.jpg"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2c23d062","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/06_Gloss.vue
// module id = 75
// module chunks = 0